<template>
  <div>
    <my-request-layout
      :workflowGuid="registration.workflowGuid"
      :foundRequest="!!registration"
      :isLoading="isLoading"
      :myRequest="registration"
      :cancelRequest="cancelRequest"
      :paymentStatus="paymentStatus"
      
      useAuthorizedPayment
      :makePayment="makePayment"
      :showPaymentAuthorizationStatus="registration.needsPaymentAuthorization"
    >
      <span slot="title">Individual Dog Registration Application</span>
      <div slot="requestContent" v-if="registration">
        
        <div class="mt-5">
          <h3>Kennel Name Usage Signatories</h3>
          <p>
            <v-simple-table
              fixed-header
              :height="
                registration && registration.kennelNameSignatories
                  ? Math.min(200, (registration.kennelNameSignatories.length + 2) * 50)
                  : 200
              "
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Name</th>
                    <th class="text-left">Membership ID</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="coOwner in registration.kennelNameSignatories"
                    :key="coOwner.personId"
                  >
                    <td>{{ coOwner.firstName }} {{ coOwner.lastName }}</td>
                    <td>{{ coOwner.memberId }}</td>
                    <td>
                      <v-tooltip dark right>
                        <template v-slot:activator="{ on, attrs }">
                          <font-awesome-icon
                            icon="signature"
                            :color="coOwner.signed ? 'green' : 'red'"
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <span>{{
                          coOwner.signed ? "Signed" : "Not signed"
                        }}</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </p>
        </div>
        <DogRegistrationIndividualRequest :registration="registration" />
      </div>
    </my-request-layout>
    <v-snackbar v-model="showErrorMessage" title color="error">
      {{ errorMessage }}
      <template v-slot:action="{ attrs }">
      <v-btn color="primary" text v-bind="attrs" @click="showErrorMessage = false">
        Close
      </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";
import MyRequestLayout from "@/components/Portal/MyRequest/MyRequestLayout.vue";
import DogRegistrationIndividualRequest from "@/components/Portal/MyRequest/DogRegistrationIndividualRequest.vue";

import workflowService from "@/services/portal/workflowService";

import { UserInfo } from "@/types/User";
import AuthorizeNetResponseData from "@/types/AuthorizeNetResponseData";

export default Vue.extend({
  name: "MyDogRegistrationIndividualRequest",
  components: {
    MyRequestLayout,
    CoownersList,
    DogRegistrationIndividualRequest,
  },
  data: function () {
    return {
      registration: Object as any,
      isLoading: false,
      paymentStatus: null,
      errorMessage: "",
      showErrorMessage: false,
    };
  },
  props: {
    workflowGuid: { type: String },
  },
  methods: {
    load() {
      this.isLoading = true;
      workflowService
        .getDogRegistrationIndividualRequestDetails(this.workflowGuid)
        .then((res) => {
          this.isLoading = false;
          this.registration = res;
        });
    },
    makePayment: function (paymentInfo: AuthorizeNetResponseData | null) {
      var req = {
        paymentInfo,
        workflowGuid: this.registration.workflowGuid,
      };

      workflowService.submitDogRegistrationIndividualCCPayment(req).then((res) => {
        if (res.error) {
          this.errorMessage = res.error;
          this.showErrorMessage = true;
        }
        else {
          this.paymentStatus = res;
        }

        this.load();
      });
    },
    cancelRequest: function () {
    },
  },
  created() {
    this.load();
  },
  watch: {
    workflowGuid: function (newValue) {
      this.load();
    },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    dogOwnershipType: function () {
      return OwnershipType.Dog;
    },
  },
});
</script>
